import { h, Fragment } from 'preact';

const ProductBadge = ({ badge }) => {
  const parts = badge.split('|');
  let badgeName;
  let badgeCollection;

  parts.forEach((part) => {
    const [key, value] = part.split(':');
    if (key === 'badge') {
      badgeName = value;
    } else if (key === 'collection') {
      badgeCollection = value;
    }
  });

  const badgeText = (text, link) => {
    const words = text.split(' ');

    return (
      <div className="h8 relative md:absolute md:top-1 md:left-3.5 mx-auto mt-2 md:mr-3.5">
        {link ? (
          <>
            <a
              href={`${Shopify.routes.root}collections/${link}`}
              className="block mx-auto lg:mx-0 no-underline w-[fit-content] text-left mt-0.5 pr-1 py-[0.188rem] md:px-2 md:py-0.5 bg-gray-0/80"
            >
              {words.slice(0, 2).join(' ')}
            </a>
            {words.length > 2 && (
              <a
                href={`${Shopify.routes.root}collections/${link}`}
                className="block mx-auto lg:mx-0 no-underline w-[fit-content] text-left mt-0.5 pr-1 py-[0.188rem] md:px-2 md:py-0.5 bg-gray-0/80"
              >
                {words.slice(2).join(' ')}
              </a>
            )}
          </>
        ) : (
          <>
            <span className="block mx-auto lg:mx-0 w-[fit-content] text-left px-1 py-[0.188rem] md:px-2 md:py-0.5 bg-gray-0/80">
              {words.slice(0, 2).join(' ')}
            </span>
            {words.length > 2 && (
              <span className="block mx-auto lg:mx-0 w-[fit-content] text-left mt-0.5 pr-1 pl-1 py-[0.188rem] md:px-2 md:py-0.5 bg-gray-0/80">
                {words.slice(2).join(' ')}
              </span>
            )}
          </>
        )}
      </div>
    );
  };

  return (
    (badgeName || badgeCollection) &&
    (badgeCollection
      ? badgeText(badgeName, badgeCollection)
      : badgeText(badgeName))
  );
};

export default ProductBadge;
